import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const QUOTE_DOWNLOAD_FORMATS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('QUOTE_DOWNLOAD_FORMATS');
export const QUOTE_DOWNLOAD_FORMATS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	QUOTE_DOWNLOAD_FORMATS_CRUD_ACTION_CONSTANTS
);
